import { useState } from 'react';
import { App, Button, Card, Flex, theme, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, faLink } from '@fortawesome/free-solid-svg-icons';
import { useGetExternalFormShareLink } from '@/features/externalForm/hooks/useExternalForm';

const { Text } = Typography;

const copyWithTextarea = (value) => {
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    return document.execCommand('copy');
  } catch (error) {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
};

const copyText = async (value) => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (error) {
      return copyWithTextarea(value);
    }
  }
  return copyWithTextarea(value);
};

export const ShareFormLink = () => {
  const { notification } = App.useApp();
  const { token: themeToken } = theme.useToken();
  const { data: url } = useGetExternalFormShareLink();
  const [copied, setCopied] = useState(false);

  if (!url) return null;

  const handleCopy = async () => {
    const copiedOk = await copyText(url);
    if (!copiedOk) {
      notification.error({ message: 'No se pudo copiar el link' });
      return;
    }
    setCopied(true);
    notification.success({ message: 'Link copiado' });
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card styles={{ body: { padding: 16 } }}>
      <Flex vertical gap={12}>
        <Flex align='center' gap={10}>
          <Flex
            align='center'
            justify='center'
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              flex: '0 0 36px',
              background: themeToken.colorPrimaryBg,
              color: themeToken.colorPrimary,
            }}
          >
            <FontAwesomeIcon icon={faLink} />
          </Flex>
          <Flex vertical gap={0}>
            <Text strong>Formulario para el cliente</Text>
            <Text type='secondary' style={{ fontSize: 12 }}>Link listo para compartir</Text>
          </Flex>
        </Flex>
        <Text
          ellipsis
          style={{
            margin: 0,
            padding: '8px 10px',
            borderRadius: 8,
            background: '#f7f8fb',
            border: '1px solid #e4e8f0',
            fontSize: 12,
          }}
        >
          {url}
        </Text>
        <Button
          block
          icon={<FontAwesomeIcon icon={copied ? faCheck : faCopy} />}
          onClick={handleCopy}
        >
          {copied ? 'Copiado' : 'Copiar link'}
        </Button>
      </Flex>
    </Card>
  );
};
